import { Stack, styled, Switch, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";


type Props = {
  checked: boolean;
  onChange : (event: React.ChangeEvent<HTMLInputElement>) => void
}



const TurnOnKpi= (
  {checked, onChange} :Props

 
 ) => {

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor:   '#00bfa5',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        'rgb(101 142 230 / 35%)',
      boxSizing: 'border-box',
    },
  }));

  const {t} = useTranslation()


  return (
    <Stack alignItems="center">
      <Typography className="h4"> {t("target.kpi.status.title")}</Typography>
    <Stack direction="row" spacing={1} alignItems="center" sx={{marginTop: "1rem"}}>
    <Typography> {t("target.kpi.status.off")}</Typography>
    <AntSwitch  inputProps={{ 'aria-label': 'ant design' }} checked={checked} onChange={onChange}/>
    <Typography> {t("target.kpi.status.on")}</Typography>
  </Stack>
  </Stack>
  );
};

export default TurnOnKpi
